// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"abm-tabs-modal-button_modalButton__QLVWf"};